<template>

  <div class="pc-page">
    <div class="test_main test_main_3">
      <Nav></Nav>
      <div class="test_detail test_3">
        <div class="radio_box">
          <h4 class="title">请仔细阅读指导语</h4>
          <div class="txt_desc">
            <p>
              1、答案没有正误之分，请根据你是怎样做的或最倾向于如何决定进行选择。 </p>
            <p>
              2、测试的目的是反映最真实的自己。请最大程度放松下来，选择更接近你平时的感受或行为的选项。
            </p>
          </div>
          <div class="btngroup test_btngroup">
            <a href="javascript:;" @click="go($event)" url="/learningAbility/LearningMotivation/1" class="btn btn_start">开始<span
              v-if="seconds">({{seconds}}s)</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
    import Nav from '../../../../components/learningAbility/learningMotivation.vue';
  export default {
    data() {
      return {
        seconds: 10
      }
    },
    mounted() {
      $('.test_menu .item').eq(0).addClass('item_3');
      var _this = this;
        this.t=setInterval(function () {
            if (_this.seconds > 0) {
                _this.seconds--;
            } else {
                clearInterval(_this.t)
            }
        }, 1000)
    },
    updated() {

    },
    components: {Nav},

    methods: {
      go: function (e) {
        var url = $(e.target).closest('a').attr('url');
//        ;
        if (this.seconds == 0) {
          this.$router.push(url);
        } else {
          this.layerMsg('请仔细阅读指导语！');
        }
      }
    }

  }
</script>

